import CityEvents from '../api/city_events';
import { notify } from './message';
import { push } from 'react-router-redux/lib/actions';
import { CmsEditorState } from 'src/api/club-cms';
import { getCurrentClubId } from '../selectors/club-settings';

const cityEvents = new CityEvents();

export const  CITY_EVENTS_UPDATE = 'CITY_EVENTS_UPDATE';
export const  CITY_EVENTS_SAVE = 'CITY_EVENTS_SAVE';
export const  CITY_EVENTS_SAVE_FAIL = 'CITY_EVENTS_SAVE_FAIL';
export const  CITY_EVENTS_SAVE_SUCCESS = 'CITY_EVENTS_SAVE_SUCCESS';
export const  CITY_EVENTS_FETCH = 'CITY_EVENTS_FETCH';
export const  CITY_EVENTS_FETCH_FAIL = 'CITY_EVENTS_FETCH_FAIL';
export const  CITY_EVENTS_FETCH_SUCCESS = 'CITY_EVENTS_FETCH_SUCCESS';

export function fetch() {
  return dispatch => {
    return Promise.resolve(dispatch({type: CITY_EVENTS_FETCH}))
      .then(() => cityEvents.fetch())
      .then((result) => dispatch({ type: CITY_EVENTS_FETCH_SUCCESS, cityEvents: result }),
        response => dispatch({ type: CITY_EVENTS_FETCH_FAIL, response, cityEvents }));
  };
}

export function save(data) {
  Object.assign(cityEvents, data);
  
  return (dispatch, getState) => {
    return Promise.resolve(dispatch({type: CITY_EVENTS_SAVE}))
      .then(async () => {
        dispatch(notify('Saving images'));
        cityEvents.club_id = getCurrentClubId(getState())
        await cityEvents.saveImages(data)
        dispatch(notify('Saving info'));
        return await cityEvents.save(data)
      })
      .then(
        () => Promise.resolve(dispatch({
          type: CITY_EVENTS_SAVE_SUCCESS,
          cityEvents
        }))
          .then(() => dispatch(notify('Changes have been saved'))),

        response => dispatch({
          type: CITY_EVENTS_SAVE_FAIL,
          response
        })
      );
  };
}

export function updateCmsEditor(cmsEditorState: CmsEditorState) {
  return {
    type: CITY_EVENTS_UPDATE,
    cmsEditorState
  }
}


// WEBPACK FOOTER //
// ./src/actions/city_events.ts